const stubs = {};
stubs.cpp = `
#include<bits/stdc++.h>
using namespace std;

int main(){

 cout<<"hello"<<endl;
 return 0;
}
`;
stubs.py = `
print("Hello World\\n")
`;

export default stubs;
